/** @jsx jsx */
import React, { Component } from 'react';
import { css, jsx } from '@emotion/core';
import styled from '@emotion/styled';

import DetailHealthCarepatchOneImg from './DetailsHealthcareSolutionCarepatch1.png';
import DetailHealthCarepatchTwoImg from './DetailsHealthcareSolutionCarepatch2.png';
import DetailHealthCarepatchThreeImg from './DetailsHealthcareSolutionCarepatch3.png';
import DetailHealthCaresprayImg from './DetailsHealthcareSolutionCarespray.png';
import DetailHealthCaresprayOneImg from './DetailsHealthcareSolutionCarespray1.png';
import DetailHealthCaresprayTwoImg from './DetailsHealthcareSolutionCarespray2.png';

const Section = styled.section`
  border: 0px solid #dadce0;

  color: #363a3c;
  
  font-family: 'Malgun Gothic';
  font-family: 'Noto Sans KR', sans-serif;
  font-family: 'Spoqa Han Sans', 'Spoqa Han Sans JP', 'Sans-serif';
`;
const SubSection = styled.div`
  margin-bottom: 50px;
`;
const ContainerFluid = styled.div`
  margin-left: auto;
  margin-right: auto;
  padding: 16px 24px;

  box-sizing: border-box;
  max-width: 1140px;
`;
const HighlightText = styled.h1`
  margin-top: 0;
  margin-bottom: 0;
  word-break: break-all;
  font-size: 20px;
  line-height: 1.6;
  
  box-sizing: border-box;
`;
const CssHeaderText100 = css`
  font-weight: 100;
`;
const CssHeaderText300 = css`
  font-weight: 300;
`;
const CssHeaderText400 = css`
  font-weight: 400;
`;
const CssTradeMarkText10 = css`
  font-size: 10px;
  font-family: 'Sans-serif';
`;
const DivFlexboxWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;
const DivFlexItem = styled.div`
  border: 0px solid #dadce0;
  box-sizing: border-box;
  width: 360px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px 0px;
`;
const ImgFlexItem = styled.img`
  width: 100%;
`;
const DivFlexboxNoWrap = styled.div`
  display: flex;
  justify-content: center;
`;
const DivFlexItemNoWrap = styled.div`
  border: 0px solid #dadce0;
  box-sizing: border-box;
  padding-top: 20px;
`;
const ImgFlexItemNoWrap = styled.img`
  width: 100%;
`;

const SpanAbsoluteBold = styled.span`
  position: absolute;
  font-weight: 700;
`;
const DivIndent20 = styled.div`
  margin-left: 20px;
`;

class DetailsHealthcareSolution extends Component {
  render() {
    return (
      <div className="DetailsHealthcareSolution">

        <Section className="section">
          <ContainerFluid className="container-fluid">

            <SubSection className="Intro">
              <p className="header-text-300" css={CssHeaderText300}>봄시스템즈는 Healthcare 제품군을 통해, 의료업무를 고도화하고, 개인의 보건을 향상 함으로써 궁극적으로 삶의 질을 높이는 데 일조하고자 합니다.</p>
            </SubSection>

            <SubSection className="SecurePrinting">
              <HighlightText className="header-text">
                <span>CarePatch</span>
              </HighlightText>

              <p className="header-text-300" css={CssHeaderText300}>CarePatch™는 무선 체온계와 네트웍을 활용하여 최소의 간호조력을 통해 실시간으로 환자의 체온 변화를 감지하여 선제적으로 대응할 수 있는 방법을 제시합니다.</p>
              <p className="header-text-300" css={CssHeaderText300}>환자의 체온은 실시간으로 전송되며, 비정상적으로 높거나 낮은 체온이 측정되면 알람을 울려서 보다 적극적인 조치를 적시에 취할 수 있게 합니다.</p>
              <p className="header-text-300" css={CssHeaderText300}>환자의 중요한 생체정보를 실시간으로 파악하여 관리함으로써, 신뢰도 높은 의료를 가능하게 하면서도 간호사 업무부담은 경감할 수 있는 특징과 장점이 있습니다.</p>

              <DivFlexboxWrap className="DivFlexboxWrap">
                <DivFlexItem><ImgFlexItem src={DetailHealthCarepatchOneImg}/></DivFlexItem>
                <DivFlexItem><ImgFlexItem src={DetailHealthCarepatchTwoImg}/></DivFlexItem>
                <DivFlexItem><ImgFlexItem src={DetailHealthCarepatchThreeImg}/></DivFlexItem>
              </DivFlexboxWrap>
            </SubSection>

            <SubSection className="Features">
              <HighlightText className="header-text">
                <span>CarePatch의 특징 및 장점</span>
              </HighlightText>
              <div>
                <div style={{position:'relative'}}>
                  <SpanAbsoluteBold>1.</SpanAbsoluteBold>
                  <DivIndent20>
                    <span>1 분 만에 끝나는 빠른 체온 측정, 오차범위는 ±0.1°C 이내</span>
                  </DivIndent20>
                </div>
                <div style={{position:'relative'}}>
                  <SpanAbsoluteBold>2.</SpanAbsoluteBold>
                  <DivIndent20>
                    <span>24 시간 체온 감지, 실시간으로 표시</span>
                  </DivIndent20>
                </div>
                <div style={{position:'relative'}}>
                  <SpanAbsoluteBold>3.</SpanAbsoluteBold>
                  <DivIndent20>
                    <span>체온이 올라가거나 내려갔을 때 자동 경보</span>
                  </DivIndent20>
                </div>
                <div style={{position:'relative'}}>
                  <SpanAbsoluteBold>4.</SpanAbsoluteBold>
                  <DivIndent20>
                    <span>자동으로 체온 그래프 제작</span>
                  </DivIndent20>
                </div>
                <div style={{position:'relative'}}>
                  <SpanAbsoluteBold>5.</SpanAbsoluteBold>
                  <DivIndent20>
                    <span>다수의 이용자의 데이터를 수용할 수 있는 데이터 연결 포트</span>
                  </DivIndent20>
                </div>
                <div style={{position:'relative'}}>
                  <SpanAbsoluteBold>6.</SpanAbsoluteBold>
                  <DivIndent20>
                    <span>디지털 진료 기록과 완벽한 동화, 자동으로 체온 데이터를 업로드</span>
                  </DivIndent20>
                </div>
              </div>
            </SubSection>

            {/*
            <SubSection className="SecurePrinting">
              <HighlightText className="header-text">
                <span>CareSpray</span>
              </HighlightText>

              <p className="header-text-300" css={CssHeaderText300}>CareSpray는 정제수와 고순도 산화아연(Zinc oxide single crystal)으로만 이루어진 무기 항균, 탈취제입니다.</p>
              <p className="header-text-300" css={CssHeaderText300}>암모니아, 유화수소 등의 악취 성분을 직접화학흡착방식으로 강력하게 흡착, 탈취하는 한편, 아연이온효과와 광촉매 효과로 넓은 스펙트럼에서 잡균의 번식을 억제하여 탁월한 항균성을 보여줍니다.</p>
              <p className="header-text-300" css={CssHeaderText300}>본 무기 항균.탈취제는 에탄올, 보존제 등과 같은 유기화학물이 들어있지 않아 안심하고 사용할 수 있습니다.</p>

              <DivFlexboxWrap className="DivFlexboxWrap">
                <DivFlexItem><ImgFlexItem src={DetailHealthCaresprayOneImg}/></DivFlexItem>
                <DivFlexItem><ImgFlexItem src={DetailHealthCaresprayTwoImg}/></DivFlexItem>
              </DivFlexboxWrap>
            </SubSection>
            */}

          </ContainerFluid>
        </Section>

      </div>
    );
  }
}

export default DetailsHealthcareSolution;
